module.exports = __webpack_public_path__ + "static/media/UTURN_LEFT.ef2dfba0.svg";